import axios from '../axios'

const uploadImg = (uploadUrl, formData) => {
  return axios({
    url: uploadUrl,
    method: 'post',
    data: formData,
    headers:{'Content-Type':'multipart/form-data'},
  })
}

// 上传图片识别条形码
const scanUploadImg = (formData) => {
  return axios.post('https://py-version.danghuan.com/imei', formData, {
    headers:{'Content-Type':'application/json'},
  })
}

// 上传文件
const policyPutUpload = (params) => {
  return axios({
    url: '/file/policyPostUpload',
    method: 'get',
    params
    // timeout: 1000 * 30
  })
}
export {
  uploadImg,
  scanUploadImg,
  policyPutUpload
}
